import { render, staticRenderFns } from "./Starter.vue?vue&type=template&id=d37f065e&scoped=true&"
import script from "./Starter.vue?vue&type=script&lang=js&"
export * from "./Starter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37f065e",
  null
  
)

export default component.exports